import posthog from 'posthog-js';

import { envFeatureFlags } from '~utils/policies';

export const isPrinterManagerFeatureEnabled = posthog.isFeatureEnabled(
  `printers${envFeatureFlags[process.env.REACT_APP_ENV]}`
);

export const isRejectedOrderManagerEnabled = posthog.isFeatureEnabled(
  `rejectedOrdersManager${envFeatureFlags[process.env.REACT_APP_ENV]}`
);

export const isShowParentModifierNameEnabled = posthog.isFeatureEnabled(
  `showParentModifierName${envFeatureFlags[process.env.REACT_APP_ENV]}`
);

export const USE_PLACES_ADDRESS = process.env.REACT_APP_USE_PLACES_ADDRESS === String(true);
